import UploadProductFile from "../components/dashboard/MainContent/Product/UploadProductFile/UploadProductFile";
import FeaturedProducts from "../components/dashboard/MainContent/Product/FeaturedProducts/FeaturedProducts";
import StadisticComponent from "../components/dashboard/MainContent/Stadistics/StadisticComponent";
import UserListComponent from "../components/dashboard/MainContent/Users/UserListComponent";
import Notification from "../components/dashboard/MainContent/Notifications/Notification";
import ProductImages from "../components/dashboard/MainContent/Product/ProductImages";
import AccessModule from "../components/dashboard/MainContent/Access/AccessModule";
import Categories from "../components/dashboard/MainContent/Categories/Categories";
import Banners from "../components/dashboard/MainContent/Banners/Banners";
import Openpay from "../components/dashboard/MainContent/Openpay/Openpay";
import Monitor from "../components/dashboard/MainContent/Monitor/Monitor";
import Center from "../components/dashboard/MainContent/Centers/Center";

const permissions = [
	{
		id: 1,
		action: "",
		description: "Permisos de Gestión de usuarios",
		icon: "people",
		label: "Área administrativa",
		subpermissions: [
			{
				id: 1,
				key: "CMS_ADMINISTRATIVE_AREA_CLIENTS",
				action: "/Users",
				route:{ path: "/Users", component: UserListComponent },
				description: "Creación de usuarios",
				icon: "face",
				label: "Usuarios",
				options: [],
			},
			{
				id: 3,
				action: "/Centers",
				route:{ path: "/Centers", component: Center },
				key: "CMS_ADMINISTRATIVE_AREA_CENTERS",
				description: "Gestión de centros",
				icon: "store",
				label: "Centros",
				options: [],
			},
			{
				id: 4,
				action: "/Openpay",
				route:{ path: "/Openpay", component: Openpay },
				key: "CMS_ADMINISTRATIVE_AREA_OPEN_PAY",
				description: "Accesos a openpay",
				icon: "payment",
				label: "Openpay",
				options: [],
			},
			{
				id: 5,
				action: "/Monitor",
				route:{ path: "/Monitor", component: Monitor },
				key: "CMS_ADMINISTRATIVE_AREA_SERVICES_MONITOR",
				description: "Monitoreo de servicios",
				icon: "computer",
				label: "Monitor de servicios",
				options: [],
			},
			{
				id: 6,
				action: "/Access",
				route:{ path: "/Access", component:AccessModule},
				key: "CMS_ADMINISTRATIVE_AREA_ACCESS",
				description: "Accesos",
				icon: "key",
				label: "Accesos",
				options: [],
			},
		],
	},
	{
		id: 2,
		action: "",
		description: "Permisos de marketing",
		icon: "business",
		label: "Marketing",
		subpermissions: [
			{
				id: 1,
				action: "/Banners",
				route:{ path: "/Banners", component: Banners },
				key: "CMS_MARKETING_AREA_BANNERS",
				description: "Administración de banners",
				icon: "photo",
				label: "Banners",
				options: [],
			},
			{
				id: 2,
				action: "/Notifications",
				route:{ path: "/Notifications", component: Notification },
				key: "CMS_MARKETING_AREA_NOTIFICATIONS",
				description: "Creación de notificaciones",
				icon: "notifications",
				label: "Notificaciones",
				options: [],
			},
			{
				id: 3,
				action: "/Product/Images",
				route:{ path: "/Product/Images", component: ProductImages },
				key: "CMS_MARKETING_AREA_IMAGES",
				description: "Administración de fotografias",
				icon: "photo",
				label: "Gestion de imágenes",
				options: [],
			},
			{
				id: 4,
				action: "/Product/Featured",
				route:{ path: "/Product/Featured", component: FeaturedProducts },
				key: "CMS_MARKETING_AREA_TOP_PRODUCTS",
				description: "Carga de productos destacados",
				icon: "auto_awesome",
				label: "Destacados",
				options: [],
			},
			{
				id: 5,
				action: "/Categories",
				route:{ path: "/Categories", component: Categories },
				key: "CMS_MARKETING_AREA_CATEGORIES",
				description: "Gestión de categorías y subcategorías",
				icon: "category",
				label: "Categorías",
				options: [],
			},
		],
	},
	{
		id: 3,
		action: "",
		description: "Permisos de dato maestro",
		icon: "text_snippet",
		label: "Dato maestro",
		subpermissions: [
			{
				id: 1,
				action: "/Product/Upload/File",
				route:{ path: "/Product/Upload/File", component: UploadProductFile },
				key: "CMS_MASTER_DATA_AREA_UPLOAD_PRODUCTS",
				description: "Carga de cátalogo excel",
				icon: "publish",
				label: "Carga de productos",
				options: [],
			},
		],
	},
	{
		id: 4,
		action: "",
		description: "Permisos de Generacion de Reportes",
		icon: "build",
		label: "Herramientas",
		subpermissions: [
			{
				id: 1,
				action: "/Estadísticos",
				route:{ path: "/Estadísticos", component:StadisticComponent},
				key: "CMS_TOOLS_AREA_REPORTS",
				description: "Manejador de Reportes",
				icon: "receipt",
				label: "Reportes",
				options: [],
			},
		],
	},
];

export default {

	GetMenuByUser : function (user) {
		let menu = [];
		
		if(!user.faculties)
			user.faculties = [];

		for (let permission of permissions) {
			
			let subp = [];

			for (let subpermission of permission.subpermissions) {
				for (let faculty of user.faculties) {
					if(faculty === subpermission.key){
						subp.push(subpermission)
					}
				}
			}

			let item = permission;
			item.subpermissions = subp;

			if(item.subpermissions.length > 0)
				menu.push(item);
		}
		return menu
	},

	GetRoutesByUser : function (user) {
		let routes = [];
		
		if(!user.faculties)
			user.faculties = [];

		for (let permission of permissions) {
			for (let subpermission of permission.subpermissions) {
				for (let faculty of user.faculties) {
					if(faculty === subpermission.key){
						routes.push(subpermission.route)
					}
				}
			}

		}
		return routes;
	}
}